import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl_ } from '../../utils/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const postRequest = (url: string, details: any, token?: string) => ({
  url,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    sessId: localStorage.getItem('sessId') ?? '',
  },
  body: details,
});

const getRequest = (url: string, token?: string) => ({
  url,
  headers: {
    Authorization: `Bearer ${token}`,
    sessId: localStorage.getItem('sessId') ?? '',
  },
});

export const businessRegistration = createApi({
  reducerPath: 'businessRegistration',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl_,
  }),
  endpoints: (builder) => ({
    getStates: builder.mutation({
      query: () => getRequest('/state/lgas'),
    }),
    getAllStateWithSterlingBranch: builder.mutation({
      query: () => getRequest('/state/branches'),
    }),
    getBusinessSector: builder.query({
      query: (credential) => getRequest('/entrepreneur/sectors', credential.token),
    }),
    verifyBvn: builder.mutation({
      query: (credential) => postRequest('/verify/bvn', credential.body, credential.token),
    }),
    registerBusiness: builder.mutation({
      query: (credential) =>
        postRequest('/entrepreneur/new-business', credential.body, credential.token),
    }),
    getRegisterBusiness: builder.query({
      query: (credential) => getRequest('/entrepreneur/new-business', credential.token),
    }),
  }),
});

export const {
  useGetStatesMutation,
  useGetAllStateWithSterlingBranchMutation,
  useVerifyBvnMutation,
  useRegisterBusinessMutation,
  useGetBusinessSectorQuery,
} = businessRegistration;
